module.exports = __webpack_public_path__ + "fonts/Formular.8e0d9e3.woff2";